import api from "./axiosInterceptor.js";

export default async function PutData(data, url) {
    try {
        const response = await api.put(`api/${url}`, data);
        if (response.status >= 200 && response.status < 300) {
            return { success: true, error: false, data: response.data };
        }
        return { success: false, error: true, data: response.data };
    } catch (err) {
        return {
            success: false,
            error: err,
            data: err?.response?.data,
            statusCode: err?.response?.status,
        };
    }
}
